export default function OTownMap({
    selectedZones,
    setSelectedZones,
    homeZone,
    setHomeZone
  }) {
    
    const handleRegionClick = (e) => {
        const zone = e.currentTarget.id;
      
        setSelectedZones(prev => {
      
          // If removing the zone
          if (prev.includes(zone)) {
      
            // If it was the home zone, clear it
            if (zone === homeZone) {
              setHomeZone(null);
            }
      
            return prev.filter(z => z !== zone);
          }
      
          // Otherwise add it
          return [...prev, zone];
        });
      };
  
    const getRegionStyle = (zone) => {
        if (zone === homeZone) {
          return {
            fill: "rgba(128,0,128,0.35)", // purple
            stroke: "#ff0004",
            strokeWidth: 10,
            cursor: "pointer"
          };
        }
        if (selectedZones.includes(zone)) {
          return {
            fill: "rgba(255,0,0,0.3)",
            stroke: "#ff0004",
            strokeWidth: 10,
            cursor: "pointer"
          };
        }
        return {
          fill: "transparent",
          stroke: "#ff0004",
          strokeWidth: 10,
          cursor: "pointer"
        };
    };


    const handleMouseEnter = (e) => {
        const zone = e.currentTarget.id;
        
        // Only apply red hover if NOT the home region
        if (zone !== homeZone) {
            e.currentTarget.style.fill = "rgba(255,0,0,0.3)";
        }
    };
      
    const handleMouseLeave = (e) => {
        const zone = e.currentTarget.id;
        
        if (zone === homeZone) {
            e.currentTarget.style.fill = "rgba(128,0,128,0.35)"; // keep purple
        } else if (selectedZones.includes(zone)) {
            e.currentTarget.style.fill = "rgba(255,0,0,0.3)";
        } else {
            e.currentTarget.style.fill = "transparent";
        }
    };

    return (
        <svg
            version="1.1"
            id="svg1"
            style={{
                height: "100vh",
                width: "auto",
                display: "block",
                margin: "0 auto"
            }}
            viewBox="0 0 1854 2600"
            xmlns="http://www.w3.org/2000/svg"
        >
        <defs
          id="defs1" />
        <g
          id="g1"
          style={{ display: "inline" }}>
         <image href="/ogden_map.jpeg" width="1854" height="2600" preserveAspectRatio="none" />
        </g>
        <g
          id="layer1"
        >
        <path
            id="North_West"
            d="M 370.60893,4.117877 C 352.68534,905.39978 377.2452,916.15393 377.2452,916.15393 l 588.85641,8.23576 5.71736,-920.271813 z"
            onClick={handleRegionClick}
            style={getRegionStyle("North_West")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
        <text
            x="650"
            y="400"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            1
        </text>
        <path
            id="North_East"
            d="m 967.87376,0 -7.16943,914.103 268.85387,3.58472 107.5415,57.35548 200.7442,57.3555 7.1694,-544.8771 7.1694,-491.1063176 z"
            onClick={handleRegionClick}
            style={getRegionStyle("North_East")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            // onClick={() => console.log("North_West clicked")}
        />
        <text
            x="1250"
            y="400"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            2
        </text>

        <path
            id="Center_West"
            d="m 365.6412,906.93356 c 30.05889,173.72964 -71.55612,463.64214 103.95681,509.02994 55.05637,211.8224 315.15079,93.7505 473.18273,139.804 l 14.33887,-638.07978 z"
            onClick={handleRegionClick}
            style={getRegionStyle("Center_West")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
        <text
            x="1250"
            y="1300"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            4
        </text>
        <path
            id="South_West"
            d="m 548.4618,1545.0133 57.35548,114.711 -35.84717,114.7109 -218.66778,258.0997 3.58472,164.897 17.92359,21.5083 175.65116,193.5748 86.03322,143.3887 39.4319,28.6777 225.83721,7.1695 v -53.7708 l 64.52492,-39.4319 v -182.8206 l -43.01661,-75.2791 21.5083,-691.8505 z"
            onClick={handleRegionClick}
            style={getRegionStyle("South_West")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
        <text
            x="650"
            y="1300"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            3
        </text>
        <path
            id="Center_East"
            d="m 949.95018,914.103 279.60802,3.58472 118.2956,57.35548 182.8206,53.7708 3.5848,544.877 -598.64789,-17.9235 z"
            onClick={handleRegionClick}
            style={getRegionStyle("Center_East")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
        <text
            x="650"
            y="2000"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            5
        </text>
        <path
            id="South_East"
            d="m 942.78074,1545.0133 -17.92359,691.8505 32.26246,68.1096 401.48839,276.0233 168.4817,-3.5847 14.3389,-1000.1362 -14.3389,-14.3389 z"
            onClick={handleRegionClick}
            style={getRegionStyle("South_East")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
        <text
            x="1250"
            y="2000"
            textAnchor="middle"
            fontSize="120"
            fill="red"
        >
            6
        </text>
       </g>
     </svg>
     
    );
  }